module.exports = __webpack_public_path__ + "img/Ticket.ee1ee0db.svg";